/* =======================================================================
   カスタムオーダー 商品詳細
   - SIZE（バリアント）選択 → hidden の variant id と価格を更新
   - 在庫のないサイズは disabled（テンプレ側で付与済み）
   - カスタマイズ項目（ボタン/リベット/ラベル/股下）は Zepto がフォーム内に
     自前のUIを挿入し、カート追加時に line item properties として送信する
   ======================================================================= */
(function () {
  'use strict';

  var D = window.DW_PRODUCT_CUSTOM;
  if (!D) { return; }

  var vidInput = document.getElementById('js-variant-id');
  var priceEl  = document.getElementById('js-price');
  var rows     = document.querySelectorAll('.js-opt-row');
  if (!vidInput || !rows.length) { return; }

  function selectedValues() {
    return Array.prototype.map.call(rows, function (row) {
      var cur = row.querySelector('.opt-btn.is-active') || row.querySelector('.opt-btn:not([disabled])');
      return cur ? cur.getAttribute('data-value') : null;
    });
  }

  function matchVariant(values) {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] !== null && v.options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) { return v; }
    }
    return null;
  }

  /* 選んだバリアントを URL の ?variant= に反映（Shopify 標準と同じ。ZenLink 等は URL だけで SKU を特定する） */
  function setVariantUrl(id) {
    try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u.toString()); } catch (e) {}
  }

  function sync() {
    var v = matchVariant(selectedValues());
    if (!v) { return; }
    vidInput.value = v.id;
    if (priceEl) { priceEl.textContent = v.price; }
    // Zepto は input[name=id] の change を見てオプション価格を再計算する
    vidInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  Array.prototype.forEach.call(rows, function (row) {
    row.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.opt-btn') : null;
      if (!btn || btn.disabled) { return; }
      Array.prototype.forEach.call(row.querySelectorAll('.opt-btn'), function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      sync();
      if (vidInput && vidInput.value) setVariantUrl(vidInput.value);
    });
  });

  sync();
})();
